import { Loader } from '@sd/components';
import {
  authenticatedUserState,
  authTktState,
  csrfTokenState,
  logger,
  oAuthService,
  sessionIdState,
  useLoading
} from '@sd/shared';
import { parse } from 'query-string';
import { Alert } from 'react-bootstrap';
import { useHistory } from 'react-router';
import { useSetRecoilState } from 'recoil';

type Props = {
  code?: string;
  state?: string;
};

export const OAuthCallbackScene = ({ code, state }: Props) => {
  const { loading, useLoadingEffect, loadingError } = useLoading();
  const backUri = (parse(state || '').back_uri || '/') as string;
  const setAuthTkt = useSetRecoilState(authTktState);
  const setCsrfToken = useSetRecoilState(csrfTokenState);
  const setSessionId = useSetRecoilState(sessionIdState);
  const setUser = useSetRecoilState(authenticatedUserState);
  const history = useHistory();

  useLoadingEffect(async () => {
    try {
      if (code) {
        const response = await oAuthService.getTokensFromAuthCode(code);
        setAuthTkt(response.authTkt);
        setCsrfToken(response.csrfToken);
        setSessionId(response.sessionId);
        setUser(response.user);

        await oAuthService.verifyAuthWithServer().catch(_e => {
          throw new Error('Unable to verify auth with the backend');
        });
        history.replace(backUri);
      }
    } catch (error) {
      if (error instanceof Error) {
        logger.error('app:login', error);
      }
      throw error;
    }
  }, [code]);

  return (
    <Loader loading={loading}>
      {loadingError && (
        <Alert variant="danger">
          No auth code provided or code is expired. Try <Alert.Link href={backUri}>logging in again</Alert.Link>.
        </Alert>
      )}
    </Loader>
  );
};
